/* Northlane — Cart count badge live update.
   Keeps .nl-hero-header__cart-count in sync with Shopify cart via /cart.js. */
(function () {
  'use strict';

  var CART_SELECTOR = '.nl-hero-header__cart';
  var BADGE_SELECTOR = '.nl-hero-header__cart-count';

  function renderBadge(count) {
    var cartLink = document.querySelector(CART_SELECTOR);
    if (!cartLink) return;
    var badge = cartLink.querySelector(BADGE_SELECTOR);
    if (count > 0) {
      if (badge) {
        badge.textContent = count;
      } else {
        badge = document.createElement('span');
        badge.className = 'nl-hero-header__cart-count';
        badge.textContent = count;
        cartLink.appendChild(badge);
      }
    } else if (badge) {
      badge.remove();
    }
  }

  function updateCartCount() {
    if (!document.querySelector(CART_SELECTOR)) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          renderBadge(cart.item_count);
        }
      })
      .catch(function () { /* swallow */ });
  }

  function init() {
    updateCartCount();

    // Theme-dispatched cart events (Horizon + many themes use these).
    var EVENTS = [
      'cart:updated', 'cart:update', 'cart:item-added', 'cart:item-removed',
      'cart:item-updated', 'cart:refresh', 'cart-drawer:open', 'cart-drawer:close'
    ];
    EVENTS.forEach(function (evt) {
      document.addEventListener(evt, updateCartCount);
      window.addEventListener(evt, updateCartCount);
    });

    // Hook into any form submission that POSTs to /cart endpoints.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      if (form.action.indexOf('/cart') !== -1) {
        setTimeout(updateCartCount, 400);
      }
    }, true);

    // Watch cart drawer DOM for changes (line items added/removed).
    var drawer = document.querySelector('cart-drawer-component, cart-drawer, [class*="cart-drawer"]');
    if (drawer && 'MutationObserver' in window) {
      var debounce;
      var mo = new MutationObserver(function () {
        clearTimeout(debounce);
        debounce = setTimeout(updateCartCount, 300);
      });
      mo.observe(drawer, { childList: true, subtree: true });
    }

    // Refresh when user returns to the tab.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') updateCartCount();
    });

    // Refresh on bfcache restore.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) updateCartCount();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
